export default __webpack_public_path__ + "424920fb53f423604a21fa6be06588e8.png";